// ofi
import objectFitImages from 'object-fit-images';
objectFitImages('.object-fit-img img');

$(function() {
    
    $.ajaxSetup({
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    });
    
    // Stripe関連処理
    if (typeof stripe !== "undefined") {

        const elements = stripe.elements();
        const cardElement = elements.create('card',{ hidePostalCode: true});
        const errorElement = $('#card-errors');
        // カード登録画面
        if ($('#card-element').length)
            cardElement.mount('#card-element');

        let formObj = ($('#card-element').length) ?
            $('#card-element').parents('form') :
            $('.purchase-button').parents('form');
        

        let cardElementComplete = false;

        // Handle real-time validation errors from the card Element.
        // カード番号
        cardElement.on('change', function(event) {
            const displayError = $('#card-errors');
            if (event.error) {
                displayError.text(event.error.message);
                displayError.show();

                $("#card-button").prop("disabled", true);
                cardElementComplete = false;
            } else if(event.complete) {
                cardElementComplete = true;
                if (formObj.find("input[name=card-holder-name]").val()) {
                    displayError.hide();

                    $("#card-button").prop("disabled", false);
                } else {
                    $("#card-button").prop("disabled", true);
                }
            } else {
                $("#card-button").prop("disabled", true);
                cardElementComplete = false;
            }
        });

        // カード名義人
        let cardHolderObj = formObj.find("input[name=card-holder-name]");
        cardHolderObj.on('input', function() {
            if ($(this).val() && cardElementComplete) 
                $("#card-button").prop("disabled", false);
            else 
                $("#card-button").prop("disabled", true);
        });

        var intent = {};

        // サーバとAjax通信してpaymentmethodを登録する
        let fetchAPI = function(bodyParams) {
            fetch(formObj.attr("action"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": formObj.find('input[name=_token]').val(),
                },
                body: JSON.stringify(bodyParams)
            })
            .then(response => response.json())
            .then(async (data) => {
                // successではない場合はエラー表示
                if (!data.success) {
                    errorElement.html('決済処理に失敗しました。<br>カード情報を更新するか、時間を置いて改めてお試しください。:' + data.error).show();
                    return false;
                }
                // 決済を行う場合
                if (data.status === "requires_action") {
                    // 3Dセキュア認証を実行
                    const { paymentIntent, error } = await stripe.confirmCardPayment(data.client_secret);
                    if (error) {
                        errorElement.html('3Dセキュア処理に失敗しました。カードをお確かめください。').show();
                    } else {
                        // エラーがなければ完了画面へリダイレクト
                        window.location.href = formObj.attr("data-complete-route") + "?status=" + paymentIntent.status;
                    }
                } else {
                    // 3Dセキュア認証がなければ完了画面へ 
                    window.location.href = formObj.attr("data-complete-route") + "?status=" + data.status;
                }
            })
            .catch(error => {
                errorElement.html('システムエラーにより処理が失敗しました。時間を置いて改めてお試しください。').show();
            });
        }
        // 決済のみのフォーム送信時
        $(".purchase-button").on("click",function() {
            // submitを禁止
            formObj.on('submit', function() { return false });
            // buttonをdisabledに
            formObj.find('button,input[type=button]').prop('disabled', true);
            // 入力値を連想配列形式へ変換
            let params = {};
            $(formObj.serializeArray()).each(function(i, v) {
                params[v.name] = v.value;
            })
            fetchAPI(params);
        });
  
        // カード番号登録フォーム送信時
        $("#card-button").on("click",function() {
            $("#card-button").prop('disabled',true);
            stripe.confirmCardSetup(
                $("#card-button").attr("data-secret"), {
                    payment_method: {
                        card: cardElement,
                        billing_details: { name: formObj.find("input[name=card-holder-name]").val() }
                    }
                }
            ).then(function(data,error) {
                if(typeof data.error !== "undefined") {
                    console.log(data.error);
                    errorElement.html('カード認証に失敗しました。カード会社にお問い合わせください。').show();
                    return false;
                }
                if(typeof data.setupIntent.payment_method === "undefined") { 
                    errorElement.html('カード登録に失敗しました。時間をおいて改めて更新してください。').show();
                    return false;
                }
                formObj.find('input[name=payment_method]').val(data.setupIntent.payment_method);
                // サーバにpayment_methodを送信
                fetchAPI({payment_method: formObj.find('input[name=payment_method]').val()});
            });
        }); 

    }

    // ナビゲーションバー
    $(document).ready(function() {
        var scrollPos;
        var $header = $('#header-contents');
        // Nav Fixed
        /* $(window).scroll(function() {
            if ($(window).scrollTop() > 350) {
                $header.addClass('fixed');
            } else {
                $header.removeClass('fixed');
            }
        }); */

        var pagetop = $('.box-back-top');
        $(window).scroll(function () {
            if (jQuery(this).scrollTop() > 500) {
                pagetop.fadeIn();
            } else {
                pagetop.fadeOut();
            }
        });
        pagetop.click(function () {
            jQuery('body, html').animate({ scrollTop: 0 }, 500);
            return false;
        });
    });

    // 返信を見るの動作
    $('.box-com-topic-more').on( 'click', function () {
        $(this).toggleClass('open-comment');
    });

    // モーダル
    $('.js-modal--show').on('click', function () {
        $('#area-event-modal').show();
    });
    $('.js-modal--cancel').on('click', function () {
        $(this).parents('#area-event-modal').hide();
    });

    // デートピッカー
    $('.js-date-picker--year').on('change', function () {
        var $parent = $(this).parents('.js-date-picker');
        var $input = $('.js-date-picker--input', $parent);
        var $month = $('.js-date-picker--month', $parent);
        var $day = $('.js-date-picker--day', $parent);
        $input.val(`${$(this).val()}-${$month.val()}-${$day.val()}`);
    });
    $('.js-date-picker--month').on('change', function () {
        var $parent = $(this).parents('.js-date-picker');
        var $input = $('.js-date-picker--input', $parent);
        var $year = $('.js-date-picker--year', $parent);
        var $day = $('.js-date-picker--day', $parent);
        $input.val(`${$year.val()}-${$(this).val()}-${$day.val()}`);
    });
    $('.js-date-picker--day').on('change', function () {
        var $parent = $(this).parents('.js-date-picker');
        var $input = $('.js-date-picker--input', $parent);
        var $year = $('.js-date-picker--year', $parent);
        var $month = $('.js-date-picker--month', $parent);
        $input.val(`${$year.val()}-${$month.val()}-${$(this).val()}`);
    });

    // videoタグは一律ダウンロード不可、右クリック不可
    $('video').attr('controlsList',"nodownload").attr('oncontextmenu',"return false;");
});

// global navi
$(function($) {
    $(function() {
        var scrollPos;
        var $header = $('#header-contents');
        // Nav Fixed
        /* $(window).scroll(function() {
            if ($(window).scrollTop() > 350) {
                $header.addClass('fixed');
            } else {
                $header.removeClass('fixed');
            }
        }); */
        // Nav Toggle Button
        $('.box-nav-toggle').click(function(){
            $header.toggleClass('open');
            if($('body').hasClass('fix')){
                $('body').removeClass('fix').css('top',0 + 'px');
                window.scrollTo( 0 , scrollPos );
            }else{
                scrollPos = $(window).scrollTop();//現在のスクロール位置
                $('body').addClass('fix').css('top',-scrollPos + 'px');
            }           
        });
    });
});

// 上に戻るボタンのフェードイン・アウト
$(function() {
    var pagetop = $('.box-back-top');
    $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
    pagetop.click(function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
    });
});

